export const figure36 = {
  chart: {
      zoomType: 'xy',
      animation: false,
      marginTop: 50,
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'bar',
      height: '1000px',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
      style: {
        fontFamily: 'Montserrat'
      }
    },

    colors: ['#5b9bd5'],

    credits: {
      enabled: false
    },
    title: {
      text: null
    },
    subtitle: {
      text: null
    },
    exporting: {
      enabled: false
    },

xAxis: [{
	categories: [
		     "Azerbaïdjan",
		     "Bélarus",
		     "Bénin",
		     "Bolivie (État plurinational de)",
		     "Bosnie-Herzégovine",
		     "Burkina Faso",
		     "Cambodge",
		     "Tchad",
		     "Chili",
		     "Colombie",
		     "Costa Rica",
		     "Ghana",
		     "Guatemala",
		     "Guyana",
		     "Italie",
		     "Jordanie",
		     "Kenya",
		     "Libéria",
		     "Madagascar",
		     "Malawi",
		     "Mali",
		     "Mexique",
		     "Mongolie",
		     "Monténégro",
		     "Myanmar",
		     "Népal",
		     "Nicaragua",
		     "Niger",
		     "Macédoine du Nord",
		     "Pakistan",
		     "Palestine",
		     "Paraguay",
		     "Pérou",
		     "Portugal",
		     "Qatar",
		     "Rwanda",
		     "Sainte-Lucie",
		     "Serbie",
		     "Sierra Leone",
		     "Slovaquie",
		     "Suriname",
		     "Suède",
		     "Suisse",
		     "Thaïlande",
		     "Togo",
		     "Turquie",
		     "République-Unie de Tanzanie",
		     "Uruguay",
		     "Ouzbékistan",
		     "Viet Nam",
		     "Yémen",
		     "Zimbabwe",
    ],
    title: {
        text: null
    }
}],
 yAxis: {
    min: 0,
    max: 6,
    tickInterval: 1,
    title: {
        text: null,
    },
    labels: {
        overflow: 'justify'
    }
},
plotOptions: {
    bar: {
        dataLabels: {
            enabled: true
        }
    }
},
legend: {
    enabled: false,
},
series: [{
    name: 'Proportion de femmes parmi les propriétaires fonciers',
    data: [3, 3, 5, 5, 3, 6, 6, 4, 2, 6, 3, 1, 5, 2, 4, 1, 5, 4, 2, 3, 3, 3, 4, 4, 1, 4, 5, 2, 4, 2, 1, 5, 5, 5, 1, 6, 1, 5, 1, 4, 2, 5, 4, 4, 4, 3, 5, 4, 3, 4, 1, 3],
}]
}